import { render, staticRenderFns } from "./Body-Calculation.vue?vue&type=template&id=f0d63dec&"
import script from "./Body-Calculation.vue?vue&type=script&lang=js&"
export * from "./Body-Calculation.vue?vue&type=script&lang=js&"
import style0 from "./Body-Calculation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports